import { faCheck, faCheckSquare, faXmark, faXmarkSquare, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type BooleanViewPropsType = {
    value?: boolean
    title?: string
    square?: boolean,
    falseIcon?: IconDefinition
    tureIcon?: IconDefinition,
    trueClassName?: string
    falseClassName?: string
}
const BooleanView = (props: BooleanViewPropsType) => {
    const trueIcon = props.square ? faCheckSquare : faCheck;
    const falseIcon = props.square ? faXmarkSquare : faXmark;
    const icon = props.value ? (props.tureIcon || trueIcon) : (props.falseIcon || falseIcon);
    const className = props.value ? (props.trueClassName || 'text-success') : (props.falseClassName || 'text-danger');
    return (
        <FontAwesomeIcon title={props.title} icon={icon} className={className} />
    );
};
export default BooleanView;
